export default [
    {
        label: "El país",
        value: "https://feeds.elpais.com/mrss-s/pages/ep/site/elpais.com/section/deportes/portada"
    },
    {
        label: "Xataca",
        value: "http://feeds.weblogssl.com/xataka2"
    },
    {
        label: "Genbeta",
        value: "http://feeds.weblogssl.com/genbeta"
    },
    /* {
        label: "El mundo - ultima hora",
        value: "https://e00-elmundo.uecdn.es/elmundo/rss/portada.xml"
    },
    {
        label: "New York Times Español",
        value: "https://rss.nytimes.com/services/xml/rss/nyt/es.xml"
    },
    {
        label: "Cointelegraph",
        value: "https://es.cointelegraph.com/rss"
    },
    {
        label: "Marca - Primera Div",
        value: "https://e00-marca.uecdn.es/rss/futbol/primera-division.xml"
    },
    {
        label: "Vogue",
        value: "https://www.vogue.com/feed/rss"
    },
    {
        label: "Ramen para dos",
        value: "https://ramenparados.com/feed/"
    },
    {
        label: "Disney",
        value: "https://anchor.fm/s/6DC76B0/podcast/rss"
    },
    {
        label: "Marvel",
        value: "https://www.universomarvel.com/feed/"
    },
    {
        label: "El país - ultimas noticias",
        value: "http://ep00.epimg.net/rss/tags/ultimas_noticias.xml"
    },
    {
        label: "ABC",
        value: "https://www.abc.es/rss/feeds/abc_ultima.xml"
    },
    {
        label: "Telva - portada",
        value: "https://e00-telva.uecdn.es/rss/portada.xml"
    },
    {
        label: "Telva - belleza",
        value: "https://e00-telva.uecdn.es/rss/belleza.xml"
    },
    {
        label: "Telva - moda",
        value: "https://e00-telva.uecdn.es/rss/moda.xml"
    },
    {
        label: "Telva - celebrities",
        value: "https://e00-telva.uecdn.es/rss/celebrities.xml"
    },
    {
        label: "Telva - cocina",
        value: "https://e00-telva.uecdn.es/rss/cocina.xml"
    },
    {
        label: "Telva - novias",
        value: "https://e00-telva.uecdn.es/rss/novias.xml"
    } */
]